<template>
  <div class="RecyclingOutlets" v-fullscreen="fullscreen">
    <div v-if="checkRoles()" class="permission-modal">
      <!-- 背景蒙层 -->
      <div class="modal-backdrop"></div>

      <!-- 弹窗内容 -->
      <div class="modal-container">
        <div class="modal-card">
          <!-- 顶部图标 -->
          <div class="modal-icon">
            <i class="el-icon-lock"></i>
          </div>

          <!-- 标题 -->
          <h3 class="modal-title">温馨提示</h3>

          <!-- 内容 -->
          <p class="modal-message">
            您暂无查看权限，如需浏览，请联系工作人员开通服务
          </p>

          <!-- 操作按钮 -->
          <div class="modal-actions">
            <el-button
              type="primary"
              size="medium"
              @click="conditionalGoBack"
              class="back-button"
            >
              返回上级目录
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
      <div class="RecyclingOutlets-head">
        <div class="RecyclingOutlets-head-weather headContent">
          <div
            @click="goHome"
            v-if="false"
            class="RecyclingOutlets-head-weather-back parallelogram"
          >
            <span class="content">返回</span>
          </div>
          <div class="RecyclingOutlets-head-weather-time">
            <img
              class="dateImg"
              :title="todayWeather.dayweather"
              :src="weatherImg[todayWeather.dayweather]"
              alt="天气预报"
            />
            <div class="timeDate">
              <div class="timeDate_top">{{ time }}</div>
              <div class="timeDate_btn">
                {{ todayWeather.city }}
                <span
                  >{{ todayWeather.nighttemp }}℃-{{
                    todayWeather.daytemp
                  }}℃</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="RecyclingOutlets-head-title headContent"
          :class="title.length > 18 ? 'changeTitleSize' : ''"
        >
          {{ title }}
        </div>
        <div class="RecyclingOutlets-head-action headContent">
          <div class="date">
            <el-select
              v-if="$store.state.chinaMap.currentlyMapAdcode"
              v-model="timeValue"
              clearable
              placeholder="请选择时间"
              @change="choseTime"
              class="zszy_cascader"
            >
              <el-option
                v-for="item in timeDictionary"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="RecyclingOutlets-head-action-area RecyclingOutlets-head-action-area-flex"
          >
            <div
                class="parallelogram"
                v-for="item in btnInfo"
                :class="{ checkedBanner: $store.state.chinaMap.dataType == item.value }"
                @click="switchData(item.value)"
            >
              <span class="content">{{item.name}}</span>
            </div>
          </div>
          <div
            v-if="!fullscreen"
            class="parallelogram RecyclingOutlets-head-action-search RecyclingOutlets-head-action-area-flex"
          >
            <div class="content" @click="screen">全屏</div>
          </div>
          <div
            v-else
            class="parallelogram RecyclingOutlets-head-action-area-flex"
          >
            <div class="content" @click="screen">退出全屏</div>
          </div>
        </div>
      </div>
      <div class="RecyclingOutlets-content">
        <left-panel />
        <center-panel />
        <right-panel />
      </div>
      <div class="RecyclingOutlets-btn"></div>
    </template>
  </div>
</template>

<script>
import LeftPanel from './components/body/left/LeftPanel.vue';
import CenterPanel from './components/body/center/CenterPanel.vue';
import RightPanel from './components/body/right/RightPanel.vue';
import { DateFormat } from '@/util/dateFormat';
import axios from 'axios';
import { getTimeDictionary } from '@/API/chinaMapApi/chinaMapApi';
export default {
  name: 'index.vue',
  components: {
    LeftPanel,
    CenterPanel,
    RightPanel,
  },
  data() {
    return {
      btnInfo:[
        {
          name:'总览',
          value:3
        },
        {
          name:'农资保供',
          value:1
        },
        {
          name:'农业社会化服务',
          value:2
        },
      ],
      userInfo: JSON.parse(localStorage.getItem('ordinaryUser')),
      title: '四川农资集团春耕保供数据大屏（储备）',
      nowDate: '',
      fullscreen: false,
      OverView: [],
      todayWeather: {
        daytemp: '',
        nighttemp: '',
        dayweather: '',
        city: '',
      },
      time: '',
      mapTimer: '',
      weatherImg: {
        多云: require('@/assets/recycling/weatherImg/多云.svg'),
        晴: require('@/assets/recycling/weatherImg/晴.svg'),
        阴: require('@/assets/recycling/weatherImg/阴天.svg'),
        阵雨: require('@/assets/recycling/weatherImg/阵雨.svg'),
        雷阵雨: require('@/assets/recycling/weatherImg/雷阵雨.svg'),
        雷阵雨伴有冰雹: require('@/assets/recycling/weatherImg/雷阵雨伴有冰雹.svg'),
        雨夹雪: require('@/assets/recycling/weatherImg/雨夹雪.svg'),
        小雨: require('@/assets/recycling/weatherImg/小雨.svg'),
        中雨: require('@/assets/recycling/weatherImg/中雨.svg'),
        大雨: require('@/assets/recycling/weatherImg/大雨.svg'),
        暴雨: require('@/assets/recycling/weatherImg/暴雨.svg'),
        大暴雨: require('@/assets/recycling/weatherImg/大暴雨.svg'),
        特大暴雨: require('@/assets/recycling/weatherImg/特大暴雨.svg'),
        阵雪: require('@/assets/recycling/weatherImg/阵雨.svg'),
        小雪: require('@/assets/recycling/weatherImg/小雪.svg'),
        中雪: require('@/assets/recycling/weatherImg/中雪.svg'),
        大雪: require('@/assets/recycling/weatherImg/大雪.svg'),
        暴雪: require('@/assets/recycling/weatherImg/暴雪.svg'),
        雾: require('@/assets/recycling/weatherImg/雾.svg'),
        冻雨: require('@/assets/recycling/weatherImg/冻雨.svg'),
        沙尘暴: require('@/assets/recycling/weatherImg/沙尘暴.svg'),
        小雨转中雨: require('@/assets/recycling/weatherImg/小雨转中雨.svg'),
        中雨转大雨: require('@/assets/recycling/weatherImg/中雨转大雨.svg'),
        大雨转暴雨: require('@/assets/recycling/weatherImg/大雨转暴雨.svg'),
        暴雨转大暴雨: require('@/assets/recycling/weatherImg/暴雨转大暴雨.svg'),
        大暴雨转特大暴雨: require('@/assets/recycling/weatherImg/大暴雨转特大暴雨.svg'),
        小雪转中雪: require('@/assets/recycling/weatherImg/小雪转中雪.svg'),
        中雪转大雪: require('@/assets/recycling/weatherImg/中雪转大雪.svg'),
        大雪转暴雪: require('@/assets/recycling/weatherImg/大雪转暴雪.svg'),
        浮尘: require('@/assets/recycling/weatherImg/浮尘.svg'),
        扬沙: require('@/assets/recycling/weatherImg/扬沙-右下.svg'),
        强沙尘暴: require('@/assets/recycling/weatherImg/强沙尘暴.svg'),
        霾: require('@/assets/recycling/weatherImg/霾.svg'),
      },
      timeValue: '',
      mapData: {},
      materials: [],
      resourceData: [],
      dataTimer: null,
      areaTopData: [], //地区排名
      growthTrendData: [], //增长趋势
      timeDictionary: [], // 时间类型字典数据
    };
  },
  mounted() {
    // 初始化数据
    this.$store.state.chinaMap.isLower = false;
    this.getTime();
    this.getWeather();
    this.updateTimeAndWeather();
    this.getTimeDer();
    // 监听全屏变化事件（修复：增加webkit和moz前缀兼容）
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener(
      'webkitfullscreenchange',
      this.handleFullscreenChange,
    );
    document.addEventListener(
      'mozfullscreenchange',
      this.handleFullscreenChange,
    );

    // 监听F11按键事件（修复：正确处理F11事件）
    document.addEventListener('keydown', (e) => {
      if (e.key === 'F11') {
        e.preventDefault(); // 阻止默认F11行为
        this.toggleFullscreen(); // 使用统一的切换方法
      }
    });
  },
  methods: {
    getTimeDer() {
      let params = {
        type: 2,
        status: 1,
      };
      getTimeDictionary(params).then((res) => {
        if (res.code === 200) {
          this.timeDictionary = res.data || [];
        }
      });
    },
    choseTime(value) {
      this.$store.commit('chinaMap/changeTimeRange', value);
    },
    goHome() {
      this.$router.push('/Home/pages');
    },
    goTopLevel() {
      this.addData(
        this.$store.state.chinaMap.dataType,
        this.$store.state.chinaMap.cityName,
      );
    },
    // 切换全省社数据
    switchData(val) {
      this.$store.commit('chinaMap/changeDataType', val);
      this.$store.commit('chinaMap/changeGlanceType', undefined);
      this.$store.commit('chinaMap/changeTimeRange', undefined);
    },
    getWeather() {
      axios
        .get('https://restapi.amap.com/v3/weather/weatherInfo', {
          params: {
            key: '8ce1786d87100ab8f6658c3404ecd3f9',
            city: 510100,
            extensions: 'all', // base:返回实况天气 all:返回预报天气
          },
        })
        .then((res) => {
          console.log(res.data, 'resresresres');
          this.todayWeather.daytemp = res.data.forecasts[0].casts[0].daytemp;
          this.todayWeather.nighttemp =
            res.data.forecasts[0].casts[0].nighttemp;
          this.todayWeather.dayweather =
            res.data.forecasts[0].casts[0].dayweather;
          this.todayWeather.city = res.data.forecasts[0].city;
        });
    },
    getTime() {
      this.time = DateFormat(new Date(), 'yyyy-MM-dd W');
      this.$store.state.chinaMap.timeHistory = this.time;
    },
    screen() {
      this.toggleFullscreen(); // 使用统一的切换方法
    },
    handleFullscreenChange() {
      this.fullscreen =
        !!document.fullscreenElement ||
        !!document.webkitFullscreenElement ||
        !!document.mozFullScreenElement;
    },
    // 修改：统一的全屏切换方法
    toggleFullscreen() {
      if (this.isFullscreen()) {
        this.exitFullscreen();
      } else {
        this.enterFullscreen();
      }
    },
    // 新增：检查是否处于全屏状态
    isFullscreen() {
      return (
        !!document.fullscreenElement ||
        !!document.webkitFullscreenElement ||
        !!document.mozFullScreenElement
      );
    },
    // 新增：进入全屏
    enterFullscreen() {
      const docEl = document.documentElement;
      if (docEl.requestFullscreen) {
        docEl.requestFullscreen();
      } else if (docEl.webkitRequestFullscreen) {
        docEl.webkitRequestFullscreen();
      } else if (docEl.mozRequestFullScreen) {
        docEl.mozRequestFullScreen();
      }
    },
    // 新增：退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      }
    },

    // 0点更新时间和天气
    updateTimeAndWeather() {
      clearInterval(this.mapTimer);
      this.mapTimer = setInterval(() => {
        const time = DateFormat(new Date(), 'yyyy-MM-dd W');
        if (time !== this.$store.state.chinaMap.timeHistory) {
          this.getTime();
          this.getWeather();
        }
      }, 1000);
    },
    conditionalGoBack() {
      this.$router.push('/Home/pages');
    },
    checkRoles() {
      let userInfo = localStorage.getItem('ordinaryUser')
        ? JSON.parse(localStorage.getItem('ordinaryUser'))
        : null;
      let status;
      if (userInfo) {
        if (userInfo.userDetail.userType == 3) {
          // 政府用户
          status = false;
        } else {
          // 普通用户和企业用户
          if (userInfo.userDetail.memberStatus == 2) {
            //如果请求的最新数据memberStatus为2则vip过期
            status = true;
            return;
          }
          // 如果是历史数据则需判断当前时间是否在vip有效期内
          if (
            userInfo.userDetail.memberStartTime &&
            userInfo.userDetail.memberEndTime
          ) {
            let result =
              new Date(userInfo.userDetail.memberStartTime).getTime() <
                new Date().getTime() &&
              new Date(userInfo.userDetail.memberEndTime).getTime() >
                new Date().getTime();
            if (!result) {
              userInfo.userDetail.memberStartTime = null;
              userInfo.userDetail.memberEndTime = null;
              userInfo.userDetail.memberStatus = 0;
              localStorage.setItem('ordinaryUser', JSON.stringify(userInfo));
              status = true;
            } else {
              status = false;
            }
          } else {
            status = true;
          }
        }
      }
      return status;
    },
  },
  destroyed() {
    clearInterval(this.mapTimer);
  },
};
</script>

<style scoped lang="less">
.RecyclingOutlets {
  width: 100vw;
  position: relative;
  height: 100vh;
  background: url('~@/assets/recycling/chinaMap/mapBackground.png') no-repeat;
  background-size: cover;
  .mapShow {
    width: 100%;
    height: 100%;
  }

  .RecyclingOutlets-head {
    background: url('~@/assets/recycling/chinaMap/header.png') no-repeat;
    background-size: cover;
    height: 88px;
    width: 100%;
    display: flex;
    align-items: center;
    .headContent {
      flex: 1;
    }
    .RecyclingOutlets-head-title {
      display: flex;
      font-weight: 700;
      align-items: center;
      font-size: 32px;
      padding-right: 20px;
      color: rgba(242, 255, 242, 1);
      justify-content: center;
    }
    .RecyclingOutlets-head-weather {
      padding-top: 65px;
      padding-left: 15px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      .RecyclingOutlets-head-weather-back {
        padding: 0 20px;
        height: 32px;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 14px;
        cursor: pointer;
      }
      .RecyclingOutlets-head-weather-time {
        margin-left: 20px;
        font-size: 14px;
        height: 43px;
        width: 215px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .dateImg {
          width: 40px;
          height: 40px;
        }
        .timeDate {
          font-size: 14px;
          margin-left: 10px;
          color: #cce7ff;
          .timeDate_top {
            font-weight: 500;
          }
          .timeDate_btn {
            margin-top: 5px;
            font-weight: 500;
            span {
              font-size: 14px;
              color: #21c25c;
            }
          }
        }
      }
    }
    .RecyclingOutlets-head-action {
      padding-top: 65px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .date {
        margin-right: 16px;
        .el-select-dropdown__item.hover,
        .el-select-dropdown__item:hover {
          background: linear-gradient(
            90deg,
            rgba(31, 115, 159, 0.1) 0%,
            rgba(21, 154, 255, 0.1) 0%,
            rgba(153, 206, 251, 0.1) 100%
          );
          color: rgba(255, 252, 252, 1);
          font-size: 14px;
          font-weight: 500;
        }
        .el-select-dropdown {
          margin-top: 0 !important;
          max-width: 200px !important;
          background: rgba(6, 74, 119, 0.9);
          border: 1px solid rgba(77, 147, 201, 1);
        }
        .el-select-dropdown__item {
          color: rgba(153, 206, 251, 1);
        }
        /deep/.el-input__inner {
          opacity: 1;
          border-radius: 2px;
          background: rgba(6, 74, 119, 0.4);
          border: 1px solid rgba(77, 147, 201, 0.6);
          color: rgba(255, 255, 255, 1);
          font-size: 14px;
          font-weight: 400;
          height: 30px;
          text-align: left !important;
          transition: all linear 0.3s;
        }

        /deep/.el-input__inner:hover {
          border: 1px solid rgba(21, 153.99999999999994, 255, 1) !important;
        }

        /deep/.el-input__inner:focus {
          border: 1px solid rgba(26, 255, 251, 1) !important;
        }
        /deep/.el-select-dropdown {
          margin-top: 0 !important;
          max-width: 200px !important;
          background: rgba(6, 74, 119, 0.9);
          border: 1px solid rgba(77, 147, 201, 1);
        }

        /deep/.el-select-dropdown__item {
          color: rgba(153, 206, 251, 1);
        }
        /deep/.el-popper[x-placement^='bottom'] .popper__arrow {
          display: none;
        }
        /deep/.el-input__icon {
          line-height: 32px;
        }
        .zszy_cascader {
          width: 150px;
          line-height: 32px;
          background: linear-gradient(
            180deg,
            rgba(0, 255, 153, 0) 0%,
            rgba(23, 153, 110, 1) 100%
          );
          /deep/.el-input__inner {
            height: 32px;
            color: #ffffff;
            background: linear-gradient(
              180deg,
              rgba(0, 255, 153, 0) 0%,
              rgba(23, 153, 110, 1) 100%
            );
            border: 1px solid;
            box-shadow:
              /* 内发光增强边框层次感 */
              inset 0 0 2px rgba(100, 255, 255, 0.6),
              /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
            border-image: linear-gradient(
              135deg,
              rgba(71, 212, 157, 1) 0%,
              rgba(1, 138, 90, 0) 47.25%,
              rgba(71, 212, 157, 1) 100%
            );
          }
          /deep/.el-select-dropdown {
            background: linear-gradient(
              180deg,
              rgba(0, 255, 153, 0) 0%,
              rgba(23, 153, 110, 1) 100%
            );
            border: 1px solid;
            box-shadow:
              /* 内发光增强边框层次感 */
              inset 0 0 2px rgba(100, 255, 255, 0.6),
              /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
            border-image: linear-gradient(
              135deg,
              rgba(71, 212, 157, 1) 0%,
              rgba(1, 138, 90, 0) 47.25%,
              rgba(71, 212, 157, 1) 100%
            );
          }
        }
      }
      .RecyclingOutlets-head-action-area {
        display: flex;
      }
      .RecyclingOutlets-head-action-search {
        padding: 0 20px;
        height: 32px;
      }
      .RecyclingOutlets-head-action-area-flex {
        margin-right: 20px;
        .search {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
  .yearSelect {
    /deep/ .el-input__inner {
      height: 32px !important;
    }
  }
  .RecyclingOutlets-content {
    margin-top: 35px;
    width: 100%;
    padding: 0 15px;
    height: calc(100% - 160px);
    display: flex;
    .RecyclingOutlets-content-left,
    .RecyclingOutlets-content-right {
      flex: 2.5;
      height: 100%;
      .rectangle4,
      .rectangle5 {
        width: 100%;
        height: 49.244%;
        margin-top: 10px;
      }
    }
    .RecyclingOutlets-content-right {
      margin-right: 20px;
    }
    .RecyclingOutlets-content-left {
      margin-left: 20px;
      .rectangle_level1,
      .rectangle_level2 {
        width: 100%;
        height: 49.83%;
      }
      .rectangle_level1 {
        margin-bottom: 10px;
      }
      .rectangle1 {
        width: 100%;
        height: 36%;
        margin-bottom: 10px;
      }
      .rectangle2,
      .rectangle3 {
        width: 100%;
        height: 31.26%;
      }
      .rectangle2 {
        margin-bottom: 10px;
      }
    }
    .RecyclingOutlets-content-map {
      flex: 5;
      height: 100%;
    }
  }
  .RecyclingOutlets-btn {
    height: 26.5px;
    background: url('~@/assets/recycling/chinaMap/btnLogo.png') no-repeat;
    background-size: cover;
  }
}
// 按钮公共样式
.parallelogram {
  //min-width: 95px; /* 宽度 */
  padding: 0 20px;
  height: 32px; /* 高度 */
  cursor: pointer;
  background: linear-gradient(
    180deg,
    rgba(0, 255, 153, 0) 0%,
    rgba(23, 153, 110, 1) 100%
  );
  border: 2px solid;
  box-shadow:
    /* 内发光增强边框层次感 */
    inset 0 0 2px rgba(100, 255, 255, 0.6),
    /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
  border-image: linear-gradient(
    135deg,
    rgba(71, 212, 157, 1) 0%,
    rgba(1, 138, 90, 0) 47.25%,
    rgba(71, 212, 157, 1) 100%
  );
  transform: skew(20deg); /* 倾斜角度 */
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 14px;
  font-family: Arial, sans-serif;
}
.parallelogram:hover {
  background: linear-gradient(
    180deg,
    rgba(7, 87, 59, 1) 0%,
    rgba(2, 54, 41, 0.5) 100%
  );
}
.checkedBanner {
  background: linear-gradient(
    180deg,
    rgba(7, 87, 59, 1) 0%,
    rgba(2, 54, 41, 0.5) 100%
  );
  border: 2px solid;
  box-shadow:
    /* 内发光增强边框层次感 */
    inset 0 0 2px rgba(100, 255, 255, 0.6),
    /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
  border-image: linear-gradient(
    135deg,
    rgba(71, 212, 157, 1) 0%,
    rgba(1, 138, 90, 0) 47.25%,
    rgba(71, 212, 157, 1) 100%
  );
}
/* 如果需要内容不倾斜，可以在内部添加一个容器 */
.parallelogram::before {
  content: '';
  position: absolute;
  z-index: -1; /* 确保背景在内容下方 */
}
.content {
  transform: skew(-20deg); /* 反向倾斜以保持内容正常 */
}
::v-deep .el-scrollbar__wrap {
  margin-bottom: -9px !important;
}
.changeTitleSize {
  font-size: 28px !important;
}
.mengban {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('~@/assets/recycling/index/mengBanBg.png') no-repeat;
  background-size: cover;
  z-index: 10000000;
  .mengban_bg {
    width: 100%;
    height: 100%;
    backdrop-filter: blur(5px); /* 背景模糊 */
    background-color: rgba(255, 255, 255, 0.2); /* 白色半透明 */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    .mengban_bg_box {
      background-color: #ffffff;
      padding: 20px;
      border-radius: 5px;
      .mengban_tips {
        text-align: center;
        font-size: 26px;
        margin-bottom: 15px;
        color: #3b3c3f;
        font-weight: 600;
      }
    }
    .backFront {
      text-align: center;
      margin-top: 10px;
      cursor: pointer;
      color: #0686efff !important;
      font-size: 18px;
    }
    .backFront:hover {
      color: rgba(143, 143, 143, 0.76) !important;
      text-underline: #999999;
    }
  }
}
.permission-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000000;
  overflow: hidden;
  background: url('~@/assets/recycling/index/mengBanBg.png') no-repeat center;
  background-size: cover;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.4s ease-in-out;
}

/* 背景蒙层 */
.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px); /* 背景模糊 */
  background-color: rgba(0, 0, 0, 0.7); /* 白色半透明 */
}

/* 弹窗容器 */
.modal-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.4s ease-in-out;
}

/* 弹窗卡片 */
.modal-card {
  width: 100%;
  max-width: 600px;
  padding: 36px 30px;
  text-align: center;
  transform: translateY(0);
  animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  border-radius: 3.13px;
  background: #044069eb;
  box-shadow:
    inset 2px 2px 10px #1afffb,
    4px 4px 16px #002740;
  backdrop-filter: blur(4px);
}

/* 图标样式 */
.modal-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background-color: #f0f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-icon i {
  font-size: 40px;
  color: #409eff;
}

/* 标题样式 */
.modal-title {
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 16px;
}

/* 消息内容 */
.modal-message {
  font-size: 20px;
  color: #ffffff;
  line-height: 1.6;
  margin: 0 0 30px;
  padding: 0 10px;
}

/* 按钮样式 */
.modal-actions {
  margin-top: 10px;
}

.back-button {
  min-width: 180px;
  height: 44px;
  font-size: 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .modal-card {
    padding: 28px 20px;
    max-width: 90%;
  }

  .modal-title {
    font-size: 20px;
  }

  .modal-message {
    font-size: 15px;
  }
}
</style>
